import React from 'react';
import 'styles/settings/fonts.css';
import 'styles/styles.scss';
import HomePage from 'pages/home';

function App() {
    return <HomePage />;
}

export default App;
